import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date('2026-06-11T00:00:00').getTime();
    const updateTimer = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(difference % (1000 * 60) / 1000)
        });
      }
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="relative glass-card border border-brand-cyan/40 shadow-[0_0_30px_rgba(0,102,255,0.2)] py-8 px-6 sm:px-12 max-w-3xl mx-auto overflow-hidden rounded-3xl" data-id="element-135">
      {/* Animated background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-cyan/10 to-transparent opacity-50" data-id="element-136"></div>

      <div className="relative z-10" data-id="element-137">
        <div className="text-center mb-8" data-id="element-138">
          <span className="text-brand-glow font-bold tracking-[0.2em] text-xs sm:text-sm uppercase flex items-center justify-center gap-2" data-id="element-139">
            <span className="relative flex h-2.5 w-2.5" data-id="element-140">
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-141"></span>
            </span>
            Live Countdown to Kickoff
          </span>
        </div>

        <div className="flex items-center justify-center gap-2 sm:gap-6" data-id="element-142">
          {/* Days */}
          <div className="flex flex-col items-center w-16 sm:w-24" data-id="element-143">
            <span className="text-4xl sm:text-6xl font-heading font-black text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]" data-id="element-144">
              {pad(timeLeft.days)}
            </span>
            <span className="text-[10px] sm:text-xs text-brand-glow uppercase tracking-widest mt-2 font-bold" data-id="element-145">
              Days
            </span>
          </div>

          <span className="text-2xl sm:text-4xl text-brand-cyan/50 font-bold pb-6" data-id="element-146">
            :
          </span>

          {/* Hours */}
          <div className="flex flex-col items-center w-16 sm:w-24" data-id="element-147">
            <span className="text-4xl sm:text-6xl font-heading font-black text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]" data-id="element-148">
              {pad(timeLeft.hours)}
            </span>
            <span className="text-[10px] sm:text-xs text-brand-glow uppercase tracking-widest mt-2 font-bold" data-id="element-149">
              Hours
            </span>
          </div>

          <span className="text-2xl sm:text-4xl text-brand-cyan/50 font-bold pb-6" data-id="element-150">
            :
          </span>

          {/* Minutes */}
          <div className="flex flex-col items-center w-16 sm:w-24" data-id="element-151">
            <span className="text-4xl sm:text-6xl font-heading font-black text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]" data-id="element-152">
              {pad(timeLeft.minutes)}
            </span>
            <span className="text-[10px] sm:text-xs text-brand-glow uppercase tracking-widest mt-2 font-bold" data-id="element-153">
              Mins
            </span>
          </div>

          <span className="text-2xl sm:text-4xl text-brand-cyan/50 font-bold pb-6" data-id="element-154">
            :
          </span>

          {/* Seconds */}
          <div className="flex flex-col items-center w-16 sm:w-24" data-id="element-155">
            <span className="text-4xl sm:text-6xl font-heading font-black text-brand-cyan drop-shadow-[0_0_20px_rgba(0,102,255,0.8)]" data-id="element-156">
              {pad(timeLeft.seconds)}
            </span>
            <span className="text-[10px] sm:text-xs text-brand-cyan uppercase tracking-widest mt-2 font-bold" data-id="element-157">
              Secs
            </span>
          </div>
        </div>
      </div>
    </div>;
}